import { render, staticRenderFns } from "./WidgetCategoryReviewsSquareGalleryMobile.vue?vue&type=template&id=909daf04"
import script from "./WidgetCategoryReviewsSquareGalleryMobile.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsSquareGalleryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports